<template>
  <div class="row d-flex justify-content-center">
    <div class="col-9">
      <table class="table">
        <tbody>
          <tr class="shadow-sm" v-for="(info, index) in rows" :key="index">
            <td-info-tag
              v-if="showInfoTag(info)"
              :data="info.value"
              :tdLabel="`${info.label}: `"
              :fieldTag="info.fieldTag"
              effect="dark"
            />
            <template
              v-else-if="info.type === 'allotments' && showRow(info)"
            >
              <td-info-lots :lots="info.value" :infoData="infoData" />
            </template>
            <template v-else-if="info.type === 'relations' && showRow(info)">
              <td-relations-block-lots
                :relations="info.value"
                :infoData="infoData"
              />
            </template>
            <template v-else-if="info.type === 'packing-houses'">
              <td-info-packing-houses
                :packing_houses="info.value"
                :infoData="infoData"
              />
            </template>
            <template v-else-if="info.type === 'management-roles'">
              <td-info-management-roles
                :managementRoles="info.value"
                :infoData="infoData"
              />
            </template>
            <td
              :style="{
                wordBreak: 'auto-phrase',
                textAlign: 'justify',
              }"
              v-else-if="
                typeof info.visibility === 'undefined' ||
                Boolean(info.visibility)
              "
            >
              <h6 class="mb-1">
                <strong>{{ info.label }}:</strong>
              </h6>
              <span v-if="validateIsset(info.value)" class="mt-2">
                {{ info.value }}
              </span>
              <el-tag v-else type="warning" effect="dark" class="mt-2">{{
                $t('common_words.no_assignment')
              }}</el-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-9">
      <div
        ref="map"
        class="map"
        v-if="renderComponent"
        style="height: 500px"
      ></div>
    </div>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import FarmService from 'src/class/FarmService.js';
import i18n from 'src/i18n';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import TdInfoLots from './TdInfoLots.vue';
import TdInfoManagementRoles from './TdInfoManagementRoles.vue';
import TdInfoPackingHouses from './TdInfoPackingHouses.vue';
import TdInfoTag from 'src/components/Tables/TdInfoTag.vue';
import TdRelationsBlockLots from './TdRelationsBlockLots.vue';

export default {
  name: 'step-confirm',
  components: {
    [TdInfoTag.name]: TdInfoTag,
    [TdInfoPackingHouses.name]: TdInfoPackingHouses,
    [TdInfoLots.name]: TdInfoLots,
    [TdInfoManagementRoles.name]: TdInfoManagementRoles,
    [TdRelationsBlockLots.name]: TdRelationsBlockLots,
  },
  props: {
    infoData: {
      typeof: Object,
      required: true,
    },
    center: {
      typeof: Object,
      required: true,
    },
  },
  data() {
    return {
      renderComponent: true,
    };
  },
  computed: {
    rows() {
      return [
        {
          label: i18n.t('common_words.farm'),
          value: this.infoData.name,
        },
        {
          label: i18n.t('common_words.code'),
          value: this.infoData.code,
        },
        {
          label: i18n.t('common_words.cost_center'),
          value: this.infoData.cost_center,
        },
        {
          label: i18n.t('common_words.area_unit'),
          value: this.infoData.area_unit,
        },
        {
          label: `${this.$t('common_words.farm_size')} (${
            this.infoData.area_unit
          })`,
          value: this.infoData.area,
        },
        {
          label: i18n.t('common_words.crop'),
          value: `${this.infoData.nameCrop} - ${this.infoData.nameCropType}`,
        },
        {
          label: i18n.t('production.weight_tara_percentage'),
          value: `${this.infoData.tara_weight} %`,
        },
        {
          label: i18n.t('production.box_unit_weight'),
          value: this.infoData.unit_box_weight,
        },
        {
          label: i18n.t('production.fruit_weight_unit'),
          value: this.infoData.unit_tara_weight,
        },
        {
          label: i18n.t('labor.length_unit'),
          value: this.infoData.length_unit,
        },
        {
          label: i18n.t('common_words.blocks_number_2'),
          value: this.infoData.name_blocks,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.sections'),
          value: this.infoData.name_sections,
          fieldTag: 'option',
          visibility: this.infoData.use_section,
        },
        {
          label: i18n.t('common_words.allotment_number_2'),
          value: this.infoData.lots_number,
          type: 'allotments',
          visibility: !this.infoData.use_section,
        },
        {
          label: i18n.t('common_words.blocks_allotment_relation_2'),
          value: this.infoData.blocks_rel,
          fieldTag: 'option',
          type: 'relations',
          visibility: !this.infoData.use_section,
        },
        {
          label: i18n.t('common_words.packing_houses'),
          value: this.infoData.packing_house_number,
          type: 'packing-houses',
        },
        {
          label: i18n.t('production.scales'),
          value: this.infoData.nameDevices,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.associated_companies'),
          value: this.infoData.names_business,
          fieldTag: 'option',
        },
        {
          label: i18n.t('common_words.administrative_role'),
          value: this.infoData.mgmt_roles,
          type: 'management-roles',
        },
        {
          label: i18n.t('common_words.notification_email'),
          value: this.infoData.email_notification,
        },
        {
          label: i18n.t('common_words.address'),
          value: `${
            this.infoData.zip_code ? `${this.infoData.zip_code} - ` : ''
          } ${this.infoData.city}, ${this.infoData.state} - ${
            this.infoData.country
          }; ${this.infoData.address ? this.infoData.address : ''}`,
        },
        {
          label: i18n.t('common_words.zone'),
          value: this.infoData.zone_name ? this.infoData.zone_name : '',
        },
        {
          label: i18n.t('common_words.subzone'),
          value: this.infoData.subzone_name ? this.infoData.subzone_name : '',
        },
        {
          label: i18n.t('common_words.geo_position'),
          value: `Lat: ${
            this.infoData.latitude
              ? this.infoData.latitude
              : i18n.t('common_words.no_assigned')
          } - Lon: ${
            this.infoData.longitude
              ? this.infoData.longitude
              : i18n.t('common_words.no_assigned')
          } 
          - Alt: ${
            this.infoData.altitude
              ? this.infoData.altitude
              : i18n.t('common_words.no_assigned')
          }`,
        },
        {
          label: i18n.t('common_words.files_loaded'),
          value: this.infoData.names_files,
          fieldTag: 'option',
        },
      ];
    },
  },
  mixins: [MixinArcgisMap],
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    showRow(info) {
      return (
        typeof info.visibility === 'undefined' || Boolean(info.visibility)
      );
    },
    showInfoTag(info) {
      return (
        this.showRow(info) &&
        this.validateIsset(info.value) &&
        Array.isArray(info.value) &&
        info.type !== 'allotments' &&
        info.type !== 'relations' &&
        info.type !== 'management-roles' &&
        info.type !== 'packing-houses'
      );
    },
    async loadMap() {
      this.renderComponent = false;
      const namesFiles = await FarmService.map(
        this.infoData,
        this.$store.state.auth.user.id
      );

      this.$nextTick(() => {
        this.renderComponent = true;
        this.loadMapMultipleC(namesFiles, false);
      });
    },
  },
};
</script>
